document.addEventListener("DOMContentLoaded", () => {
    if (/iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream) {
        return; // Ne pas exécuter le script sur iOS
    }
    ready(); // Exécuter la fonction normalement sur les autres systèmes
});
function ready() {
    const stickyElement = document.getElementById("df-sticky-element");
    const chevron = document.getElementById("df-sticky-chevron");
    const sommaire = document.getElementById("df-sticky-sommaire");
    const stickyList = document.getElementById("df-sticky-list");
    const mainMenu = document.getElementById('main-menu');
    if (stickyElement && mainMenu) {
        const height = mainMenu.getBoundingClientRect().height;
        setTimeout(() => {
            const newHeight = mainMenu.getBoundingClientRect().height;
            stickyElement.style.top = newHeight + 'px';
        }, 100);
        function toggleSticky() {
            stickyElement.classList.toggle("shrunk");
        }
        const items = stickyList.getElementsByTagName("li");
        for (let item of items) {
            item.addEventListener("click", () => {
                toggleSticky();
            });
        }
        chevron.addEventListener("click", () => {
            toggleSticky();
        });
        sommaire.addEventListener("click", () => {
            toggleSticky();
        });
        window.addEventListener("scroll", () => {
            const stickyRect = stickyElement.getBoundingClientRect();
            if (stickyRect.top <= height && stickyRect.bottom > 0) {
                stickyElement.classList.add("df-stick-visible");
            } else {
                stickyElement.classList.remove("df-stick-visible");
            }
        });
    }
}
